<template>
    <div class="jump-order nav-bar-fixed">
        <van-nav-bar title="会员码" left-arrow fixed
                     @click-left="back"
        />
        <div class="integral-header">
            <!--van-circle
                    v-model="currentRate"
                    :rate="100"
                    :speed="0"
                    color="#fff"
                    size="120px"
                    layer-color="#fff"
                    :stroke-width="60"
            >-->
            <div class="circle-text">

                <p><img :src="'data:image/png;base64,'+data"/></p>

            </div>
            <!--</van-circle>-->
        </div>

    </div>
</template>
<script>
    import {NavBar, Circle, Row, Col, List, Button} from "vant";

    export default {
        name: "userintegral",
        components: {
            [Button.name]: Button,
            [NavBar.name]: NavBar,
            [Circle.name]: Circle,
            [Row.name]: Row,
            [List.name]: List,
            [Col.name]: Col
        },
        data() {
            return {
                data:''
            };
        },
        mounted() {
            let that = this;
            this.$api.get(that.jumuc.userCenter.getQrCode, null,
                successRes => {
                    // console.log(successRes)
                    if (successRes.success) {
                        that.data = successRes.data
                    }
                })
        },
        methods: {
            back() {
                history.back();
            }
        }
    };
</script>
<style lang="less" scoped>
    @bule-thame: #3c6eeb;
    body {
        background-color: #f7f7f7;
    }

    .van-hairline--bottom::after {
        border-width: 0px;
    }

    .jump-order {

        .integral-header {
            /* background-color: @bule-thame;*/
            text-align: center;
            padding: 20px 0 60px;
            position: relative;
            .circle-text {
                height: 120px;
                color: #fff;
                position: relative;
                p {
                    font-size: 26px;
                    line-height: 100px;
                }
                span {
                    position: absolute;
                    bottom: 30px;
                    left: 35px;
                    font-size: 14px;
                }
            }
        }
        .integral-detail {
            background-color: #fff;
            margin-top: 10px;
            padding: 10px 15px 20px;
            h5 {
                font-size: 16px;
                padding: 10px 0;
                border-bottom: 1px solid #ebedf0;
                color: #333;
            }
            &-item {
                border-bottom: 1px dashed #ebedf0;
                padding: 20px 0 10px;
                color: #ccc;
                p {
                    font-size: 16px;
                    color: #333;
                }
                .detail-num {
                    font-size: 20px;
                    &.add {
                        color: #f5a623;
                    }
                    &.plus {
                        color: #ccc;
                    }
                }
            }
        }
        .detail-no-more {
            text-align: center;
            padding: 10px;
            font-size: 14px;
            color: #ccc;
        }
    }
</style>


